import { render } from "./BattleTDPage.vue?vue&type=template&id=0d03cfed&scoped=true&ts=true"
import script from "./BattleTDPage.vue?vue&type=script&lang=ts"
export * from "./BattleTDPage.vue?vue&type=script&lang=ts"

import "./BattleTDPage.vue?vue&type=style&index=0&id=0d03cfed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d03cfed"]])

export default __exports__